import React, { Component } from "react";
import { Container, Form, Button } from "react-bootstrap";
import "./Contact.css";

class Contact extends Component {
  constructor() {
    super();

    this.state = {
      quote: "",
      fullname: "",
      email: "",
      telephone: "",
      location: "",
      howdidyou: "",
      feedback: "",
      name: "Contact Form",
      contact_email: "bambi@bbmuniversal.co.za"
    };
 
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit(e) {
    e.preventDefault();

    const {
      quote,
      fullname,
      email,
      telephone,
      location,
      howdidyou
    } = this.state;
    console.log("sending form", this.state);

    const templateId = "adrodmedia";

    this.sendFeedback(templateId, {
      message_html:
        "Quote: " +
        this.state.quote +
        "<br /> Fullname: " +
        this.state.fullname +
        "<br /> Email: " +
        this.state.email +
      "<br /> Telephone: " +
      this.state.telephone +
      "<br /> Location: " +
      this.state.location +
      "<br /> How did you hear about us: " +
      this.state.howdidyou,
      from_name: this.state.name,
      reply_to: this.state.email
    });

    alert("it works!");
  }

  sendFeedback(templateId, variables) {
    window.emailjs
      .send("gmail", templateId, variables)
      .then(res => {
        console.log("Email successfully sent!", variables);
      })
      // Handle errors here however you like, or use a React error boundary
      .catch(err =>
        console.error(
          "Oh well, you failed. Here some thoughts on the error that occured:",
          err
        )
      );
  }

  render() {
    return (
      <div>
        <div className="banner_all">
          <Container>
            <h1>Contact</h1>
          </Container>
        </div>

        <Container>
          <div className="row">
            <div className="col-sm-5">
              <div className="row concard">
                <div className="col-sm-2">
                  <i className="fas fa-street-view"></i>
                </div>
                <div className="col-sm-10">
                  <h5>OFFICE LOCATION</h5>
                  <p>BBM UNIVERSAL (PTY) 306 Besswill,</p>
                  <p>Corner Elsa & Weir street,</p>
                  <p>Pretoria Gardens</p>
                </div>
              </div>
              <div className="row concard">
                <div className="col-sm-2">
                  <i className="fas fa-tty"></i>
                </div>
                <div className="col-sm-10">
                  <h5>CONTACT DETAILS</h5>
                  <p>+27 (0)61 967 9859</p>
                  <p>info@bbmuniversal.co.za </p>
                </div>
              </div>
              <div className="row concard">
                <div className="col-sm-2">
                  <i className="far fa-clock"></i>
                </div>
                <div className="col-sm-10">
                  <h5>WORKING HOURS</h5>
                  <p>Mon to Fri – 8AM to 4PM</p>
                  <p>Sat-Sun – Closed</p>
                </div>
              </div>
            </div>
            <div className="col-sm-7">
              <h3>Contact Us</h3>

              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId="formGridState">
                  <Form.Control
                    size="lg"
                    as="select"
                    name="quote"
                    onChange={this.handleChange}
                  >
                    <option>Get a quote</option>
                    <option>Start a project</option>
                    <option>General inquiries</option>
                    <option>Other</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group controlId="formBasicFullname">
                  <Form.Control
                    size="lg"
                    type="text"
                    name="fullname"
                    onChange={this.handleChange}
                    placeholder="Full Name"
                  />
                </Form.Group>
                <Form.Group controlId="formBasicEmail">
                  <Form.Control
                    size="lg"
                    type="email"
                    name="email"
                    onChange={this.handleChange}
                    placeholder="Enter email"
                  />
                </Form.Group>
                <Form.Group controlId="formBasicTelephone">
                  <Form.Control
                    size="lg"
                    type="text"
                    name="telephone"
                    onChange={this.handleChange}
                    placeholder="Telephone Number"
                  />
                </Form.Group>
                <Form.Group controlId="formBasicLocation">
                  <Form.Control
                    size="lg"
                    type="text"
                    name="location"
                    onChange={this.handleChange}
                    placeholder="Location"
                  />
                </Form.Group>
                <Form.Group controlId="formGridState">
                  <Form.Control
                    size="lg"
                    as="select"
                    name="howdidyou"
                    onChange={this.handleChange}
                  >
                    <option>How did you hear about us?</option>
                    <option>Social Media</option>
                    <option>Search Engine</option>
                    <option>Referrals </option>
                    <option>Other</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlTextarea1">
                  <Form.Control
                    as="textarea"
                    rows="6"
                    name="message"
                    onChange={this.handleChange}
                    placeholder="Tell us about your project"
                  />
                </Form.Group>
                <Button
                  className="button rounded-pill"
                  variant="danger"
                  size="lg"
                  type="submit"
                >
                  Submit
                </Button>
              </Form>
            </div>
          </div>
        </Container>
        <div className="pagespacing"></div>
      </div>
    );
  }
}

export default Contact;
